import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import CustomInput from '../../../../utils/redux-forms-custom-fields/CustomInput';
import RichText from '../../../../utils/RichText';

const FAQs = ({
  fields,
  onRemove,
  onRichTextUpdate
}) => {
  const fieldValues = fields.getAll();

  return (
    <div>
      {fields.map((step, index) => (
        <div key={index} className="faqs_wrapper">
          <button
            className="remove_faq"
            type="button"
            onClick={() => onRemove(fields, index)}
          >
            Remove FAQ
          </button>

          <Field
            name={`${step}.title`}
            id={`${step}.title`}
            type="text"
            component={CustomInput}
            label="Question"
            placeholder="Question"
            customLabel="Question"
          />

          <div className="input-container">
            <label>Answer</label>
            <RichText
              initialValue={fieldValues[index].description}
              callback={content => onRichTextUpdate(content, `faqs[${index}].description`)}
            />
          </div>
        </div>
      ))}

      <button 
        className="add_faq" 
        type="button" 
        onClick={() => fields.push({ question: null, answer: null })}
      >
        Add FAQ
      </button>
    </div>
  );
};

FAQs.propTypes = {
  fields: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  onRichTextUpdate: PropTypes.func.isRequired
};

export default FAQs;